import React from "react";
import Layout from "./Layout";
import CentralSection from "../sections/CentralSection";

const Central = () => {
  return (
    <>
      <Layout>
        <CentralSection />
      </Layout>
    </>
  );
};

export default Central;
